module.exports = __webpack_public_path__ + "static/media/scene5_didi4.7e18da51.wav";